export const Close = () => {
    return (
        <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m15 5-10 10m0-10 10 10"
                stroke="var(--cm-p-text-primary)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
        </svg>
    );
};
